// extracted by mini-css-extract-plugin
module.exports = {"slider":"AddProductsModal_slider__3E5RZ","container":"AddProductsModal_container__qQRDz","header":"AddProductsModal_header__GUm8F","tab":"AddProductsModal_tab__2UQzB"};